import { SelectionProps } from "@/interfaces/SelectionProps";
import { FC } from "react";
import {
  PriceFormField,
  PriceRangeSliderMax,
  PriceRangeSliderMin,
  PriceRangeSliderStep,
  PriceRangeSliderUnit,
} from "@/consts/RangeSlider";
import RangeSlider from "@/components/RangeSlider";
import SearchScafold from "@/components/SearchScafold";
import useRangeSlider from "@/hooks/useRangeSlider";

const PriceSelection: FC<SelectionProps<PriceFormField>> = ({
  defaultValue,
  onUpdate,
  onBack,
}): JSX.Element => {
  const slider = useRangeSlider({
    defaultMin: defaultValue.min_price,
    defaultMax: defaultValue.max_price,
    min: PriceRangeSliderMin,
    max: PriceRangeSliderMax,
  });

  return (
    <SearchScafold
      title={"価格"}
      handleSubmit={() => {
        onUpdate({
          min_price: slider.minQueryValue,
          max_price: slider.maxQueryValue,
        });
        onBack();
      }}
    >
      <div className="p-20">
        <RangeSlider
          rangeSlider={slider}
          step={PriceRangeSliderStep}
          unit={PriceRangeSliderUnit}
        />
      </div>
    </SearchScafold>
  );
};
export default PriceSelection;
